import { Box, Flex } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { Header } from "../../components/Header";
import { Filter } from "./Filter";
import { Lista } from "./Lista";
import { RelatorioFilter, useRelatorios } from "../../hooks/relatorio/useRelatorio";
import { useRelatorioResumo } from "../../hooks/relatorio/useResumoRelatorio";
import { isRepresentante } from "../../libs/auth";

function getCurrentMonthRange(representanteOnly: boolean): RelatorioFilter {
  const now = new Date();
  const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
  const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);

  const toDateString = (date: Date) => {
    const dia = String(date.getDate()).padStart(2, "0");
    const mes = String(date.getMonth() + 1).padStart(2, "0");

    return `${dia}/${mes}/${date.getFullYear()}`;
  };

  const filter: RelatorioFilter = {
    data_inicial: toDateString(firstDay),
    data_final: toDateString(lastDay),
  };

  if (representanteOnly) {
    filter.status = "3";
  }

  return filter;
}

export function Pedidos() {
  const representanteOnly = isRepresentante();
  const form = useForm()
  const filtrar = form.watch("filter");
  const [filter, setFilter] = useState<RelatorioFilter | undefined>(() => getCurrentMonthRange(representanteOnly));
  const [page, setPage] = useState(1);

  useEffect(() => {
    if (filtrar !== undefined) {
      setFilter(filtrar);
      setPage(1);
    }
  }, [filtrar]);

  const { data, isLoading } = useRelatorios({ page, filter });
  const { data: dataResumo } = useRelatorioResumo({ filter });

  return (
    <FormProvider {...form}>
      <Box
        display={"flex"}
        flexDir={"column"}
        justifyContent={"center"}
        width={"full"}
        alignItems={"center"}
      >
        <Flex
          maxWidth={"90%"}
          width={"100%"}
          flexDir={"column"}
          justifyContent={"center"}
        >
          <Header />
          <Box
            px={"1rem"}
            bg={"white"}
            w={"full"}
            display={"flex"}
            flexDir={"column"}
            gap={"8"}
            pb={8}
          >
            <Filter />
            <Lista
              data={data}
              dataResumo={dataResumo}
              filter={filter}
              isLoading={isLoading}
              setPage={setPage}
            />
          </Box>
        </Flex>
      </Box>
    </FormProvider>
  );
}
